import { render, staticRenderFns } from "./StoreHours.vue?vue&type=template&id=4895156a&"
import script from "./StoreHours.vue?vue&type=script&lang=js&"
export * from "./StoreHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports